import React, { useEffect, useState } from 'react';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import Slide from '@mui/material/Slide';
import { Avatar, BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import FileFolderEditIcon from '../../../common/Icons/FileFolderEditIcon';
import { stringToHslColor } from '../../../../utils/helpers';
import { HomeIcon, TimeExpenseIcon } from '../../../common/Icons';
import colors from '../../../../scss/colors';
import BaseSwipeableDrawer from '../../../common/BaseSwipeableDrawer/BaseSwipeableDrawer';
import { ProfileCard } from '../ProfileButton/ProfileButton';

function HideOnScroll(props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({
    target: window ? window() : undefined
  });

  return (
    <Slide appear={false} direction="up" in={!trigger}>
      {children}
    </Slide>
  );
}

const buttonStyles = {
  '&.MuiButtonBase-root.MuiBottomNavigationAction-root': {
    minWidth: '24px'
  },
  '&.MuiButtonBase-root.MuiBottomNavigationAction-root > .PrivateSwipeArea-root': {
    display: 'none'
  }
};

const swiper = {
  width: '50px',
  height: '8px',
  borderRadius: '10px',
  background: colors.LIGHT_GREY
};

export default function FooterPanel() {
  const [t] = useTranslation();
  const navigate = useNavigate();

  const accessTo = useSelector((state) => state.accessToParts);

  const [value, setValue] = useState(0);
  const [open, setOpen] = useState(false);
  const [loggedout, setLoggedout] = useState(false);

  const logoutIdentifier = () => {
    setLoggedout(true);
  };
  const openDrawer = () => {
    setOpen(!open);
  };
  useEffect(() => {
    setValue(window.location.pathname);
  }, []);

  return (
    <HideOnScroll>
      <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, height: '60px' }} elevation={3}>
        <BottomNavigation
          showLabels
          value={value}
          onChange={(event, newValue) => {
            setValue(newValue);
            navigate(newValue);
          }}
        >
          <BottomNavigationAction
            label={t('common.header.menu.home')}
            icon={<HomeIcon />}
            sx={buttonStyles}
            value="/dashboard"
          />
          {!accessTo.tAndEApprover && (
            <BottomNavigationAction
              label={t('dashboard.jobs.job')}
              icon={<WorkOutlineIcon />}
              sx={buttonStyles}
              value="/dashboard/jobs"
            />
          )}
          {accessTo.onboarding && (
            <BottomNavigationAction
              label={t('common.header.menu.onboarding')}
              icon={<FileFolderEditIcon />}
              sx={buttonStyles}
              value="/dashboard/tifo"
            />
          )}
          {(accessTo.tAndEContractor || accessTo.tAndEApprover) && (
            <BottomNavigationAction
              label={t('dashboard.timesheets.sidetabTimeShort')}
              icon={<TimeExpenseIcon />}
              sx={buttonStyles}
              value="/dashboard/timesheets"
            />
          )}
          {(accessTo.tAndEContractor || accessTo.tAndEApprover) && (
            <BottomNavigationAction
              label={t('dashboard.expenses.sidetabExpense')}
              icon={<PaidOutlinedIcon />}
              sx={buttonStyles}
              value="/dashboard/expenses"
            />
          )}
          <BottomNavigationAction
            onClick={() => openDrawer()}
            label={t('common.header.menu.profile')}
            icon={
              <>
                <Avatar
                  sx={{
                    width: 24,
                    height: 24,
                    bgcolor: stringToHslColor(
                      `${localStorage.getItem('AirswiftFirstName')?.[0] || ''} ${
                        localStorage.getItem('AirswiftLastName')?.[0] || ''
                      }`,
                      20,
                      40
                    ),
                    '&.MuiAvatar-root': {
                      fontSize: 12,
                      color: colors.WHITE,
                      fontWeight: 600
                    }
                  }}
                >
                  {(localStorage.getItem('AirswiftFirstName')?.[0] || '') +
                    (localStorage.getItem('AirswiftLastName')?.[0] || '')}
                </Avatar>
                <BaseSwipeableDrawer open={open} closeHandler={() => setOpen(false)}>
                  <div style={swiper} />
                  <ProfileCard logoutIdentifier={logoutIdentifier} logoutStatus={loggedout} />
                </BaseSwipeableDrawer>
              </>
            }
            sx={buttonStyles}
          />
        </BottomNavigation>
      </Paper>
    </HideOnScroll>
  );
}
